import { Radio, Row, Col, Affix, Button } from "antd";
import React, { Component } from "react";
import logo from "../assets/images/logo-payap.png";
// Run: เพิ่มใหม่ เพื่อทำ dynamic Language 16/04/2021

import { logout } from "../utils/AuthGuard";


//import dom
import { Link, Redirect } from "react-router-dom";


export default class HeaderComponent extends Component {
  constructor(props) {
    super(props);

  }

  componentWillMount() {
    if (localStorage.length == 0) {
      localStorage.setItem("Language", "TH");
    }
  }

  handleLogout() {
    localStorage.clear();
    localStorage.setItem("Language", "TH");
    logout();
  }



  render() {
    const language = localStorage.getItem("Language")

    console.log("render");
    console.log("/locals=a=sc", localStorage.getItem("Language"));

    return (
      <Affix offsetTop={0}>
        <div style={{ backgroundColor: "#018FD6", padding: 10 }}>
          <Row>
            <Col style={{ padding: "10px 0", marginLeft: 15 }}>
              
             
            </Col>
            <Col
              span={12}
              style={{ marginLeft: 15, color: "#fff", fontSize: 16 }}
            >
              <p>
                สำนักทรัพยากรบุคคล <br /> Office of Human Resources
              </p>
            </Col>

            <p style={{ color: "#fff", fontSize: 16, padding: "10px 0" }}>
              เลือกภาษา
            </p>
            <div style={{ padding: "10px 0", marginLeft: 15 }}>
              <Radio.Group
                defaultValue={localStorage.getItem("Language")}
                buttonStyle="solid"
              >
                 <Radio.Button value="TH" onClick={()=> this.props.data.changeLang("TH")}>ไทย</Radio.Button>
                 <Radio.Button value="EN" onClick={()=> this.props.data.changeLang("EN")}>English</Radio.Button>
              </Radio.Group>
            </div>
            <div
              style={{ padding: "10px 0", marginLeft: 15 }}
              onClick={this.handleLogout}
            >
              <Button>
                {language == "TH" ? (
                  <Link to="/"> ออกจากระบบ </Link>
                ) : (
                  <Link to="/"> Sign Out </Link>
                )}
              </Button>
            </div>
          </Row>
        </div>
      </Affix>
    );
  }
}
